import React from 'react';
import "./styles.css";

export const PartnerComponentV2 = () => (
	<React.Fragment>
        <div class="Focusouter">
            <div class="title">
                <div class="focusSubTitle">
                    Partners
                </div>
                <div class="focusingSubContent">
                    Some of the best clients and organizations I worked/partner with.
                </div>
            </div>
            <div class="PartnerMain">
                <img className='imgLogo logo1' src={process.env.PUBLIC_URL+ "/img/as.png"}/>
                <img className='imgLogo logo2' src={process.env.PUBLIC_URL+ "/img/eureka.png"}/>
                <img className='imgLogo logo3' src={process.env.PUBLIC_URL+ "/img/google.png"}/>
                <img className='imgLogo logo4' src={process.env.PUBLIC_URL+ "/img/ieee.png"}/>
                <img className='imgLogo logo5' src={process.env.PUBLIC_URL+ "/img/now-ai.png"}/>
                <img className='imgLogo logo6' src={process.env.PUBLIC_URL+ "/img/ITRI-logo.png"}/>
                <img className='imgLogo logo7' src={process.env.PUBLIC_URL+ "/img/kerry.png"}/>
                <img className='imgLogo logo8' src={process.env.PUBLIC_URL+ "/img/tsmc.png"}/>
            </div>
        </div>
        
	</React.Fragment>
);